/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './dashboard.component.scss.shim.ngstyle';
import * as i1 from '../../../node_modules/bootstrap/dist/css/bootstrap.css.shim.ngstyle';
import * as i2 from '@angular/core';
import * as i3 from '@angular/router';
import * as i4 from './target-validation/target-validation-dialog.component.ngfactory';
import * as i5 from '../../../../src/app/main/target-validation/target-validation-dialog.component';
import * as i6 from '../../../../src/app/main/target-validation/target-validation.service';
import * as i7 from '@angular/common';
import * as i8 from '../modals/modal-loading.component.ngfactory';
import * as i9 from '../../../../src/app/modals/modal-loading.component';
import * as i10 from '../../../../src/app/modals/modal.service';
import * as i11 from '../modals/modal-error.component.ngfactory';
import * as i12 from '../../../../src/app/modals/modal-error.component';
import * as i13 from '../../../../src/app/main/dashboard.component';
import * as i14 from '../../../../src/app/publisher/publisher.service';
const styles_DashboardComponent:any[] = [i0.styles,i1.styles];
export const RenderType_DashboardComponent:i2.RendererType2 = i2.ɵcrt({encapsulation:0,
    styles:styles_DashboardComponent,data:{}});
export function View_DashboardComponent_0(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[i2.ɵqud(402653184,1,{targetValidationModal:0}),i2.ɵqud(402653184,
      2,{errorModal:0}),i2.ɵqud(402653184,3,{loadingModal:0}),(_l()(),i2.ɵted((null as any),
      ['﻿'])),(_l()(),i2.ɵeld(0,(null as any),(null as any),4,'div',[['class','dashboard'],
      ['id','dashboard']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i2.ɵted((null as any),['\n    '])),(_l()(),i2.ɵeld(16777216,
      (null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),
      (null as any),(null as any),(null as any))),i2.ɵdid(212992,(null as any),0,i3.RouterOutlet,
      [i3.ChildrenOutletContexts,i2.ViewContainerRef,i2.ComponentFactoryResolver,[8,
          (null as any)],i2.ChangeDetectorRef],(null as any),(null as any)),(_l()(),
      i2.ɵted((null as any),['\n'])),(_l()(),i2.ɵted((null as any),['\n'])),(_l()(),
      i2.ɵeld(0,(null as any),(null as any),1,'dialog-target-validation',([] as any[]),
          (null as any),(null as any),(null as any),i4.View_TargetValidationDialog_0,
          i4.RenderType_TargetValidationDialog)),i2.ɵdid(114688,[[1,4],['targetValidationDialog',
      4]],0,i5.TargetValidationDialog,[i6.TargetValidationService,i7.Location],(null as any),
      (null as any)),(_l()(),i2.ɵted((null as any),['\n'])),(_l()(),i2.ɵeld(0,(null as any),
      (null as any),1,'modal-loading',([] as any[]),(null as any),(null as any),(null as any),
      i8.View_LoadingModal_0,i8.RenderType_LoadingModal)),i2.ɵdid(114688,[[3,4],['loadingModal',
      4]],0,i9.LoadingModal,[i10.ModalService],(null as any),(null as any)),(_l()(),
      i2.ɵted((null as any),['\n'])),(_l()(),i2.ɵeld(0,(null as any),(null as any),
      1,'modal-error',([] as any[]),(null as any),(null as any),(null as any),i11.View_ShowErrorModal_0,
      i11.RenderType_ShowErrorModal)),i2.ɵdid(114688,[[2,4],['errorModal',4]],0,i12.ShowErrorModal,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,7,0);
    _ck(_v,11,0);
    _ck(_v,14,0);
    _ck(_v,17,0);
  },(null as any));
}
export function View_DashboardComponent_Host_0(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,(null as any),(null as any),1,'dashboard',([] as any[]),
      (null as any),(null as any),(null as any),View_DashboardComponent_0,RenderType_DashboardComponent)),
      i2.ɵdid(114688,(null as any),0,i13.DashboardComponent,[i14.PublisherService,
          i10.ModalService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const DashboardComponentNgFactory:i2.ComponentFactory<i13.DashboardComponent> = i2.ɵccf('dashboard',
    i13.DashboardComponent,View_DashboardComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21haW4vZGFzaGJvYXJkLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvc3JjL2FwcC9tYWluL2Rhc2hib2FyZC5jb21wb25lbnQudHMiLCJuZzovLy9zcmMvdWkvc3JjL2FwcC9tYWluL2Rhc2hib2FyZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL21haW4vZGFzaGJvYXJkLmNvbXBvbmVudC50cy5EYXNoYm9hcmRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCLvu788ZGl2IGlkPVwiZGFzaGJvYXJkXCIgY2xhc3M9XCJkYXNoYm9hcmRcIj5cbiAgICA8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG48L2Rpdj5cbjxkaWFsb2ctdGFyZ2V0LXZhbGlkYXRpb24gI3RhcmdldFZhbGlkYXRpb25EaWFsb2c+PC9kaWFsb2ctdGFyZ2V0LXZhbGlkYXRpb24+XG48bW9kYWwtbG9hZGluZyAjbG9hZGluZ01vZGFsPjwvbW9kYWwtbG9hZGluZz5cbjxtb2RhbC1lcnJvciAjZXJyb3JNb2RhbD48L21vZGFsLWVycm9yPiIsIjxkYXNoYm9hcmQ+PC9kYXNoYm9hcmQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs4RENBQTtNQUFBLFFBQUM7TUFBQTtNQUFBLGdCQUFzQywyQ0FDbkM7TUFBQTtNQUFBLG1EQUFBO01BQUE7VUFBQSxrRUFBK0I7YUFBQSx3QkFDN0IsdUNBQ047YUFBQTtVQUFBOzhDQUFBLFVBQUE7TUFBQTtNQUFBLGVBQTZFLHVDQUM3RTtNQUFBO3VEQUFBLFVBQUE7TUFBQSxzRUFBNkM7YUFBQSx3QkFDN0M7TUFBQTttQ0FBQSxVQUFBO01BQUE7SUFKSTtJQUVKO0lBQ0E7SUFDQTs7OztvQkNMQTtNQUFBO2FBQUE7MEJBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./aot_output/src/app/main/dashboard.component.ngfactory.ts